import { useEffect, useRef, useState } from "react";
import { LocationIcon } from "../../assets/Assets";
import fallbackLocationImage from "../../assets/fallbackLocationImage.webp";
import useLiveLocation from "../../services/getLocation";
import useMap from "../../services/useMap";
import { calculateDistance, openInNewTab } from "../../utils/constants";
import NoToiletsFoundFallback from "../../assets/NoToiletsFoundFallback.svg"


function FindPct(props) {
  const mapContainer = useRef(null);
  const [locationAccess, setLocationAccess] = useState(false);
  const [nearByPCTs, setNearByPCTs] = useState([]);
  const [locationPermissionState, setLocationPermissionState] =
    useState("prompt");

  const currentLocation = useLiveLocation(
    true,
    setLocationAccess,
    locationAccess
  );

  useMap(
    nearByPCTs,
    mapContainer,
    locationAccess,
    currentLocation,
    (objectId) => {
      console.log("objectId", objectId);
    }
  );

  const checkLocationPermissionStatus = () => {
    if (navigator.permissions) {
      navigator.permissions.query({ name: "geolocation" }).then((result) => {
        setLocationPermissionState(result.state);
      });
    }
  };

  const requestLocationPermission = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        console.log("requestLocationPermission", position);
        setLocationPermissionState("granted");
        window.location.reload();
      },
      (error) => {
        if (error.code === error.PERMISSION_DENIED) {
          console.log("requestLocationERROR", error);
          checkLocationPermissionStatus();
        }
      }
    );
  };

  useEffect(() => {
    if (locationPermissionState === "granted") {
      setLocationAccess(true);
    } else {
      setLocationAccess(false);
    }

    // eslint-disable-next-line
  }, [locationPermissionState]);

  useEffect(() => {
    checkLocationPermissionStatus();
  }, []);

  //   set location data
  useEffect(() => {
    if (currentLocation && props.locations) {
      let locationWithDistance = []
       props?.locations?.forEach((location) => {
        const distance = calculateDistance(
          { latitude: location._geoloc.lat, longitude: location._geoloc.lng },
          currentLocation
          
        );
        // less than 5KM
        if(distance <= 5000){
          locationWithDistance.push({ ...location, distance })
        }
      });

      const sortedData = locationWithDistance.sort(
        (a, b) => a.distance - b.distance
      );

      if(sortedData.length > 0)
      setNearByPCTs([
        ...sortedData.slice(0, 4),
        {
          type: "userLocation",
          _geoloc: {
            lat: currentLocation.latitude,
            lng: currentLocation.longitude,
          },
        },
      ]);
    }
  }, [props.locations, currentLocation]);

  return (
    <div id="findPct" ref={props.sectionRefs.findPct} className="w-full">
      <div className="flex flex-col justify-center items-center py-8 md:py-14">
        <div className="font-bold text-xl md:text-3xl">Toilets Nearby</div>
      </div>
      <div className="w-full h-fit md:h-[500px] flex justify-center items-center bg-slate-50">
        {locationAccess ? (
          <div className="w-full h-full flex flex-col-reverse md:flex-row justify-center items-center">
            <div className="w-full md:w-[40%] h-fit md:h-full pt-4  md:pl-10 md:pt-10 flex flex-wrap overflow-scroll">
              {nearByPCTs.length > 0 ? (
                nearByPCTs.map(
                  (data, index) =>
                    data.type !== "userLocation" && (
                      <div
                        key={index}
                        className=" w-[50%] md:w-full pb-4 pl-6 md:pl-14 md:pb-6 cursor-pointer"
                        onClick={() => {
                          openInNewTab(
                            `https://www.google.com/maps?q=${data._geoloc.lat},${data._geoloc.lng}`
                          );
                        }}
                      >
                        <div className=" flex items-top">
                          <div className=" h-[16px], w-[16px] pt-[6px]">
                            <LocationIcon color="#0075FF" />
                          </div>
                          <div
                            className="font-bold text-lg pl-1 md:pl-2">
                            {data.location}{" "}
                          </div>
                        </div>
                        <div className="text-sm pl-5 md:pl-6 ">
                          {`${(data.distance / 1000).toFixed(2)} Km`}
                        </div>
                        <div className="text-sm pl-5 md:pl-6 ">
                          No: {data.PCTNo}
                        </div>
                        <div className="text-sm pl-5 md:pl-6  ">
                          Ward: {data.ward}
                        </div>
                        <div className="text-sm pl-5 md:pl-6 ">
                          Zone: {data.zone}
                        </div>
                      </div>
                    )
                )
              ) : (
                <div className=" w-full h-full flex flex-col justify-center items-center">
                  <img alt="NoToiletsFoundFallback" src={NoToiletsFoundFallback} height={120} width={120} />
                  <div className="text-gray-600 text-lg font-semibold text-center">No nearby toilets found</div>
                  <div className="text-gray-600 text-center">No toilets currently available within 5KM radius, upcoming facilities planned ahead</div> 
                </div>
              )}
            </div>
            {nearByPCTs.length > 0 ? <div
              ref={mapContainer}
              className="w-full md:w-[60%] h-[500px] md:h-full"
            /> : <></>}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center h-full py-8">
            <img src={fallbackLocationImage} alt="fallbackImg" width="104px" />
            <p className="text-gray-600 mb-2 mt-4 text-center">
              Location access is required to show nearby toilets.
            </p>

            {locationPermissionState === "prompt" && (
              <button
                onClick={requestLocationPermission}
                className="bg-blue-500 text-white px-4 py-2 hover:bg-blue-600 transition-colors"
              >
                Enable Location Access
              </button>
            )}

            {locationPermissionState === "denied" && (
              <p className="text-red-500 px-4 py-2 text-center">
                Location access blocked. Enable in browser settings.
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default FindPct;
